import styled, { device, themeGet } from "@theme/utils";
export const LoginAndRegisterArea = styled.div`
    padding-top: 80px;
    padding-bottom: 80px;
`;
export const LoginAndRegisterContent = styled.div``;
